import classNames from "classnames"
import React, { useMemo } from "react"
import isNumber from 'lodash/isNumber'
import { toUnitValStrWithFormat } from "./utils"
import { useSelector } from "react-redux"
import { getActiveUnitSet } from "@/store/project/selector"

interface LabelWithUnitRowProps {
  label: string
  value: number
  dimCode?: string
  className?: string
}

export const LabelWithUnitRow = (props: LabelWithUnitRowProps) =>{
  const {label, value, className, dimCode} = props
  const unitSet = useSelector(getActiveUnitSet)
  const varUnitData = useMemo(() => {
    if (!(unitSet && dimCode)){
      return;
    }
    return unitSet.units.find(item => item.dimcode === dimCode)
  }, [unitSet, dimCode])

  const unitString = varUnitData?.unit.code

  const varLabel = `${label}[${unitString ?? '-'}]`
  const valueStr = isNumber(value) ? toUnitValStrWithFormat(value as number, varUnitData): value as number
  
  return <div className={classNames('flex-space-btw', 'mt-1', className)}>
    <div>{varLabel}:</div>
    <div>{valueStr ?? '-'}</div>
  </div>
}